import { render, staticRenderFns } from "./ExtractionField.vue?vue&type=template&id=43406a15&scoped=true&"
import script from "./ExtractionField.vue?vue&type=script&lang=js&"
export * from "./ExtractionField.vue?vue&type=script&lang=js&"
import style0 from "./ExtractionField.vue?vue&type=style&index=0&id=43406a15&lang=scss&scoped=true&"
import style1 from "./ExtractionField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43406a15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent})
